module.exports = {
  merchantCount: "50,000"
};



// WEBPACK FOOTER //
// ./src/data/merchants.js